// What `graph-embed.js` imports as `./mycorr_graph.js` (vite.config.mts): the
// engine target_wasm carries, initialised before <App/> renders.
export { GraphEmbed } from "target_wasm";

// eslint-disable-next-line no-restricted-syntax -- graph-embed.js imports `init` as the default
export default async function init(): Promise<void> {}
